export { default as AssessmentConsentForm } from './ConsentForm';
export { default as BhaQrCode } from './QrCode';
